/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { TicketStatus } from './TicketStatus';
import {
    TicketStatusFromJSON,
    TicketStatusFromJSONTyped,
    TicketStatusToJSON,
} from './TicketStatus';

/**
 * 
 * @export
 * @interface TicketMessageDto
 */
export interface TicketMessageDto {
    /**
     * 
     * @type {number}
     * @memberof TicketMessageDto
     */
    tenantId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TicketMessageDto
     */
    ticketId?: number;
    /**
     * 
     * @type {string}
     * @memberof TicketMessageDto
     */
    message?: string | null;
    /**
     * 
     * @type {TicketStatus}
     * @memberof TicketMessageDto
     */
    ticketStatus?: TicketStatus;
}

/**
 * Check if a given object implements the TicketMessageDto interface.
 */
export function instanceOfTicketMessageDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TicketMessageDtoFromJSON(json: any): TicketMessageDto {
    return TicketMessageDtoFromJSONTyped(json, false);
}

export function TicketMessageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketMessageDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'ticketId': !exists(json, 'ticketId') ? undefined : json['ticketId'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'ticketStatus': !exists(json, 'ticketStatus') ? undefined : TicketStatusFromJSON(json['ticketStatus']),
    };
}

export function TicketMessageDtoToJSON(value?: TicketMessageDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'ticketId': value.ticketId,
        'message': value.message,
        'ticketStatus': TicketStatusToJSON(value.ticketStatus),
    };
}

